import React from "react";
import "../../styles/CaseStudyFour/CaseStudiesCallout4.css";
import productIcon1 from "../../assets/magnifying-glass-icon.png";
import productIcon2 from "../../assets/two-cogs.png";
import productIcon3 from "../../assets/purple-people.png";
import { Link } from 'react-router-dom';

const CaseStudiesCallout4 = () => {
  return (
    <section className="case-callout-section4">
      <div className="case-callout-container4">
        {/* Title */}
        <h2 className="case-callout-title4">Ready to Make Your Case Study?</h2>

        {/* Description Text */}
        <p className="case-callout-description4">
            Let our team handle your toughest marketing challenges while you handle how to maintain growth with our scalable solutions and services.
        </p>

        {/* Product/Service Boxes */}
        <div className="case-callout-product-container4">
          <div className="case-callout-box4">
            <img
              src={productIcon1}
              alt="Product/Service Callout 1"
              className="case-callout-icon4"
            />
            <p>End-To-End Tracking</p>
          </div>
          <div className="case-callout-box4">
            <img
              src={productIcon2}
              alt="Product/Service Callout 2"
              className="case-callout-icon4"
            />
            <p>CRM Integration</p>
          </div>
          <div className="case-callout-box4">
            <img
              src={productIcon3}
              alt="Product/Service Callout 3"
              className="case-callout-icon4"
            />
            <p>Audience & Keyword Optimization</p>
          </div>
        </div>
      </div>

      {/* CTA Below Cards */}
      <div className="case-callout-cta4">
        <p className="case-callout-cta-text4">Click below to Schedule Your FREE Growth Audit!</p>
        <Link to="/lead-form" className="case-callout-cta-button4">Get Your Growth Audit</Link>
      </div>

    </section>
  );
};

export default CaseStudiesCallout4;
